<template>
  <div class="detail-attach">
    <upload-attach v-if="canUpload && hasUpFilePower" class="upload-btn" @uploaded="uploadedFile"></upload-attach>
    <new-table ref="attchTableRef" :data="attachList" :columns="columns"></new-table>
  </div>
</template>
<script>
import NewTable from "@/components/new-table";
import UploadAttach from "@/views/components/upload-attach";
import { downloadWithUrl, FileSize } from "@/utils/util";
import { ContractApis } from "@/apis";

export default {
  name: "contract-detail-attach",
  props: {
    contract: Object,
    canUpload: { default: true },
  },
  data() {
    return {
      hasUpFilePower: this.$store.getters.isAuth("HTSCFJ"),
      attachList: [],
      columns: [
        { label: "文件名称", prop: "fileName" },
        { label: "附件大小", render: (h, { row }) => FileSize(row.fileSize) },
        { label: "上传人", prop: "uploadUserName" },
        { label: "上传时间", prop: "creationTime", width: "135px" },
        { label: "来源", prop: "fileSource" },

        {
          label: "操作",
          width: "100px",
          render: (h, { row }) => (
            <span>
              <auth-button code="HTXZFJ" size="mini" type="text" onClick={() => this.download(row)}>
                下载
              </auth-button>
              {this.contract.state === 2 && (
                <auth-button code="HTDEFJ" size="mini" type="text" onClick={() => this.deleAttach(row)}>
                  删除
                </auth-button>
              )}
            </span>
          ),
        },
      ],
      isShowingMsg: false,
    };
  },
  mounted() {
    this.getAttachs();
  },
  methods: {
    getAttachs() {
      ContractApis.getContractAttachs(this.contract.id).then((res) => {
        this.attachList = res;
      });
    },
    uploadedFile(file) {
      let params = {
        id: this.contract.id,
        attachList: [file],
      };
      ContractApis.addContractAttach(params).then((res) => {
        this.debangce();
        this.getAttachs();
      });
    },
    debangce() {
      if (!this.isShowingMsg) {
        this.$message.success("上传成功");
        this.isShowingMsg = true;
        setTimeout(() => {
          this.isShowingMsg = false;
        }, 3000);
      }
    },
    download(row) {
      downloadWithUrl(`${this.$ossUrl}${row.filePath}`, row.fileName);
    },
    async deleAttach(row) {
      await this.$confirm("确定要删除该附件吗？", "注意", { type: "warning" });
      const res = await ContractApis.deleContractAttach(row.id);
      if (res) {
        this.$message.success("附件删除成功！");
        const index = this.attachList.findIndex((r) => r.id === row.id);
        this.attachList.splice(index, 1);
      }
    },
  },
  components: { NewTable, UploadAttach },
};
</script>
<style scoped lang="scss">
.detail-attach {
  .upload-btn {
    text-align: right;
  }
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
